// base.js
// Empty application placeholder

import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

export default function BaseApp() {
  return (
    <Box sx={{ height: '100vh', width: '80vw', display: 'flex', flexDirection: 'column' }}>
      <Paper elevation={3} sx={{
        p: 4,
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        width: '80vw',
        height: '100vh',
        borderRadius: 0
      }}>
        <Typography variant="h6" align="center" gutterBottom>
          Application vide
        </Typography>
        <Typography variant="body1" align="center" color="textSecondary">
          Empty application
        </Typography>
      </Paper>
    </Box>
  );
}